import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class Seo {
  private title = inject(Title);
  private meta = inject(Meta);

  setTitle(title?: string) {
    const _title = `Gains.com | ${title ?? 'The Premier Social Casino'}`;

    this.title.setTitle(_title);
    this.meta.addTag({ name: 'title', property: 'og:title', content: _title });
    this.meta.addTag({ property: 'twitter:title', content: _title });
  }

  setDescription(description: string) {
    this.meta.addTag({
      name: 'description',
      property: 'og:description',
      content: description,
    });
  }

  setImage(imageUrl: string) {
    this.meta.addTag({
      name: 'image',
      property: 'og:image',
      content: imageUrl,
    });
    this.meta.addTag({ property: 'twitter:image', content: imageUrl });
  }
}
